// import _ from 'lodash';

export interface Customer {
  id: number
  primaryIndustryName?: string
  primaryIndustryId?: number
  slider1: number
  slider2: number
  slider3: number
  slider4: number
  slider5: number
  website: string
  blog: string
  twitter: string
  audience: string
  voiceAndPersonality: string
  contentExample: string
  otherInfo: string
  activeKeywordsCount: number
  hasPlan?: boolean
  plan?: {
    id: number
  }
}

// #############################################################################
// ####                         ABOUT SUBSECTIONS                           ####
// #############################################################################

export function industryComplete(customer: Customer): boolean {
  return !!(customer && (customer.primaryIndustryName || customer.primaryIndustryId) )
}

export function toneComplete(customer: Customer): any {
  return customer && (!isNullOrUndefined(customer.slider1) || !isNullOrUndefined(customer.slider2) || !isNullOrUndefined(customer.slider3) || !isNullOrUndefined(customer.slider4) || !isNullOrUndefined(customer.slider5))
}

// export function toneComplete(customer: Customer): any {
//   return customer && (customer.slider1 || customer.slider2 || customer.slider3 || customer.slider4 || customer.slider5);
// }

export function onlinePresenceComplete(customer: Customer): any {
  return customer && (customer.website || customer.blog || customer.twitter)
}

export function audienceAndVoiceComplete(customer: Customer): any {
  return customer && (customer.audience || customer.voiceAndPersonality)
}

export function otherInfoComplete(customer: Customer): any {
  return customer && (customer.contentExample || customer.otherInfo)
}


// #############################################################################
// ####                               ABOUT                                 ####
// #############################################################################

export function aboutComplete(customer: Customer): boolean {
  return industryComplete(customer) &&
          toneComplete(customer) &&
          onlinePresenceComplete(customer) &&
          audienceAndVoiceComplete(customer) &&
          otherInfoComplete(customer)
}

// #############################################################################
// ####                              TOPICS                                 ####
// #############################################################################


export function topicsComplete(customer: Customer): boolean {
  return customer && customer.activeKeywordsCount > 0
}

// #############################################################################
// ####                               PLAN                                  ####
// #############################################################################


export function planComplete(customer: Customer): boolean {
  return customer && customer.hasPlan
}

// #############################################################################
// ####                     EARLIEST UNFINISHED ROUTE                       ####
// #############################################################################

export function earliestUnfinishedRoute(account: {agency: boolean, accountProfile: any, createdByAdmin: string}, customer: Customer): Array<string|Object> {
  const isBusiness = !account.agency
  let root: Array<string|Object> = getRootRoute(isBusiness)
  if (!account.accountProfile) {
    return ['/account', 'signup']
  } else if (!customer && !isBusiness) {
    return ['/account', 'signup']
  } else if (account.createdByAdmin && planComplete(customer)) {
    return root.concat([customer.id, 'payment'])
  } else if (!planComplete(customer)) {
    return root.concat([customer.id, 'plan'])
  } else {
    if (isBusiness) {
      // Businesses Should be taken to payment if complete
      return root.concat([customer.id, 'payment'])
    } else {

      // Agencys should just be taken to first page if they've finished completing this customer
      return root.concat([customer.id, 'about', 'industry'])
    }
  }
}

// #############################################################################
// ####                    EARLIEST UNFINISHED ABOUT ROUTE                  ####
// #############################################################################

export function earliestUnfinishedAboutRoute(customer: Customer, isBusiness: boolean = false): Array<string|Object> {

  let root: Array<string|Object> = getRootRoute(isBusiness)
  if (!industryComplete(customer)) {
    return root.concat([customer.id, 'about', 'industry'])
  } else if (!toneComplete(customer)) {
    return root.concat([customer.id, 'about', 'tone'])
  } else if (!onlinePresenceComplete(customer)) {
    return root.concat([customer.id, 'about', 'online_presence'])
  } else {
    return root.concat([customer.id, 'about', 'other_info'])
  }
}

function getRootRoute(isBusiness: boolean = false): Array<string|Object> {
  let root: Array<string|Object>
  if (isBusiness) {
    root = ['/signup/v1']
  } else {
    root = ['/account', 'signup', 'clients', 'setup']
  }
  return root
}

function isNullOrUndefined(thing: any): boolean {
  return typeof(thing) === 'undefined' || thing === null
}
